const breakpoints = {
    large: "1407px",
    medium: "1166px",
    small: "768px",
};

export default breakpoints;